import app from './public/app.vue'
import tabList from './public/tab_list.vue'
import scrollList from './public/scroll_list.vue'
import scrollItem from './public/scroll_item.vue'
import detailCard from './public/detail_card.vue'
import buttonGroup from './public/button_group.vue'

import cForm from './form/index.vue'
import cFormColumn from './form/column.vue'
import cFormItem from './form/item.vue'

import cDetail from './detail/index.vue'
import cDetailItem from './detail/item.vue'

import cTitle from './unit/title.vue'
import cHint from './unit/hint.vue'
import cInput from './unit/input.vue'
import cButton from './unit/button.vue'
import cRadio from './unit/radio.vue'
import cRadioGroup from './unit/radio_group.vue'
import cCheckbox from './unit/checkbox.vue'
import cCheckboxGroup from './unit/checkbox_group.vue'
import cSelect from './unit/select.vue'
import cDatetime from './unit/datetime.vue'
import cColor from './unit/color.vue'
import cLink from './unit/link.vue'
import cMedia from './unit/media.vue'
import cFile from './unit/file.vue'
import cEditor from './unit/editor.vue'
import cSwitch from './unit/switch.vue'
import cUploadMedia from './unit/upload_media.vue'
import cUploadFile from './unit/upload_file.vue'

import cDialog from './dialog/index.vue'

// 导出组件
export default {
	install: function(Vue) {
		Vue.component('app', app);
		Vue.component('tabList', tabList);
		Vue.component('scrollList', scrollList);
		Vue.component('scrollItem', scrollItem);
		Vue.component('detailCard', detailCard);
		Vue.component('buttonGroup', buttonGroup);
		
		Vue.component('cTitle', cTitle);
		Vue.component('cHint', cHint);
		Vue.component('cInput', cInput);
		Vue.component('cButton', cButton);
		Vue.component('cRadio', cRadio);
		Vue.component('cRadioGroup', cRadioGroup);
		Vue.component('cCheckbox', cCheckbox);
		Vue.component('cCheckboxGroup', cCheckboxGroup);
		Vue.component('cSelect', cSelect);
		Vue.component('cDatetime', cDatetime);
		Vue.component('cColor', cColor);
		Vue.component('cLink', cLink);
		Vue.component('cMedia', cMedia);
		Vue.component('cFile', cFile);
		Vue.component('cEditor', cEditor);
		Vue.component('cSwitch', cSwitch);
		Vue.component('cUploadMedia', cUploadMedia);
		Vue.component('cUploadFile', cUploadFile);
		
		Vue.component('cForm', cForm);
		Vue.component('cFormColumn', cFormColumn);
		Vue.component('cFormItem', cFormItem);
		
		Vue.component('cDetail', cDetail);
		Vue.component('cDetailItem', cDetailItem);
		
		Vue.component('cDialog', cDialog);
    }
}